import React, { useCallback, useContext, useEffect, useState } from "react";
import dayjs from 'dayjs';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTranslation } from "react-i18next";
import { FormControl, Stack } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { debounce } from "lodash";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector } from "react-redux";

export default function DateRange(props) {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const rightTree = useSelector((state) => state.treeData[parentScreen].rightTree);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    const submitChange = useCallback((changedDate, name) =>{
        const isInvalidYear = dayjs(changedDate).year() < 1900;
        if (isInvalidYear) props.dateErrorHandler(name === "DATE_MIN" ? 'min' : 'max', true);
        if (isInvalidYear && name === "DATE_MIN") setMinDate(props.DATE_MIN);
        if (isInvalidYear && name === "DATE_MAX") setMaxDate(props.DATE_MAX);
        if (!isInvalidYear && dayjs(changedDate).isValid()) props.SetMindateMaxdate(changedDate, name);
    });

    const debounceChangeHandler = useCallback(debounce(submitChange, 200), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    useEffect(()=>{
        setMinDate(props.DATE_MIN);
        setMaxDate(props.DATE_MAX);
    },[props.DATE_MIN,props.DATE_MAX,selectedNode?.key])


    return (
        <>
            <FormControl className="width-100" size="small">
                <Stack spacing={"10px"} className="tp-segment">
                    <div className="flex">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker 
                                label={t("LBL_MIN_DATE")}
                                variant="outlined"
                                size="small"
                                className={"width-100 date-range"}
                                format="YYYY/MM/DD"
                                type="date"
                                name="DATE_MIN"
                                value={dayjs(minDate)}
                                onChange={(value) => {
                                    const changedDate = dayjs(value)?.format('YYYY/MM/DD')
                                    setMinDate(changedDate);
                                    debounceChangeHandler(changedDate, "DATE_MIN");
                                }}
                                slotProps={{
                                    textField :{
                                        error : Boolean(props?.dateError?.min)
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                </Stack>
                <div className="flex">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            variant="outlined"
                            size="small"
                            label={t("LBL_MAX_DATE")}
                            className={"width-100 date-range"}
                            format="YYYY/MM/DD"
                            type="date"
                            name="DATE_MAX"
                            value={(dayjs(maxDate))}
                            onChange={(value) => {
                                const changedDate = dayjs(value)?.format('YYYY/MM/DD')
                                setMaxDate(changedDate);
                                debounceChangeHandler(changedDate, "DATE_MAX");
                            }}
                            slotProps={{
                                textField :{
                                    error : Boolean(props?.dateError?.max)
                                }
                            }}
                        />
                    </LocalizationProvider>
                </div>
            </FormControl>
        </>
    )
}
